<template>
  <div class="tabbed" v-if="!blast.isOpen && blast.assignment.features.reviews">
    <ul class="tabbed-nav">
      <li :class="{active: activeTab==tab.key}" v-for="tab in tabs" :key="tab.key"><button @click.prevent="activeTab = tab.key">{{ tab.label }}</button></li>
    </ul>
    <div class="tabbed-content">
      <blast-reviews-received :blast="blast" v-if="activeTab == 'received'" />
      <blast-reviews-given :blast="blast" v-if="activeTab == 'given'" />
    </div>
  </div>
</template>

<script>

  import mixin from "./mixin.js"

  export default {
    name: 'ReviewDisplay',
    mixins: [mixin],
    data () {
      return {
        activeTab: 'received',
        tabs: [
          { key: 'received', label: `Reviews Received (${this.blast.reviewsReceivedCount || 0})` },
          { key: 'given', label: `Reviews Given (${this.blast.reviewsGivenCount || 0})` }
        ]
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

  .tabbed {

    margin-top:3rem;

    &-nav {
      @include list-style-reset;
      display:flex; position:relative;
      > li {
        border:1px solid #b2b2b2; flex-basis:50%;
        &.active {
          background:#fff; border-bottom-color:#fff;
        }
        &:first-child {
          border-radius:3px 0 0 0 ;
        }
        &:last-child {
          border-radius:0 3px 0 0 ;
        }
        & + li {
          margin-left:-1px;
        }
      }
      button {
        @include button-reset;
        width:100%; padding:.5rem 0; font-size:75%; font-weight:600;
      }
    }

    &-content {
      border:1px solid #b2b2b2; margin-top:-1px; padding:1rem; background:#fff; font-size:80%; border-radius:0px 3px 3px 3px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/BlastStudent/ReviewDisplay.vue